import { axiosInstance } from './api'

import { Creative, PUTCreative, StreamGET } from 'types/creative'
import { EntityPage, Paging } from 'types/paging'

export const creativesApi = {
  create(params: FormData) {
    return axiosInstance.post('creatives/create', params)
  },
  paging(params: Paging) {
    return axiosInstance.post<EntityPage<Creative>>('creatives/paging', params)
  },
  getOne(id: number) {
    return axiosInstance.get<Creative>(`creatives/${id}`)
  },
  update(id: number, params: PUTCreative) {
    return axiosInstance.put(`creatives/${id}`, params)
  },
  delete(id: number) {
    return axiosInstance.delete(`creatives/${id}`)
  },
  getStreamData(id: number) {
    return axiosInstance.get<StreamGET>(`creatives/${id}/setup-stream`)
  },
}
